import { useEffect, useState } from "react";
import axios from "axios";
import img1 from '../images/approve.png';
import img2 from '../images/msgicon1.png';
import loadIcon from '../images/loader2.webp';
function SubscriberMessages()
{
    const [messages,setMessages]=useState([]);
    const [progress,setProgress]=useState(false);
    const apiClient = axios.create({
        baseURL: process.env.REACT_APP_APIURL, // Replace with your API base URL
        headers: {
            'Content-Type': 'application/json',
            'Authorization':'Bearer '+localStorage.getItem("token")
        }
    });  
    async function loadMessages()
    {
        setProgress(true);
        await apiClient.get(process.env.REACT_APP_APIURL+"/api/Messages/GetAllMessages").then(res=>
        {
            if(res.status==200)
            {
                setMessages(res.data.data);                                
            }
        });               
        setProgress(false);
    }    
    async function approveMessage(id)
    {
        if(window.confirm('Are you sure?'))
        {
            setProgress(true);
            await apiClient.post(process.env.REACT_APP_APIURL+"/api/messages/ApproveMessage/"+id).then(res=>
            {
                if(res.status==200 && res.data.status=="OK")
                {
                     alert("Message approved successfully!"); 
                     loadMessages();
                }
                else
                {
                    alert("Some Error!!!");    
                }
            });               
            setProgress(false);
        }
    }
    useEffect(()=>{
        loadMessages();
    },[]);
    return(
        <div>
            <div><img src={img2} style={{width:'20px',height:'20px'}} /> Unapproved Messages</div>
            <table className="table table-bordered table-striped" style={{fontSize:'12px'}}>
                <thead>
                    <tr>
                        <th>S.No.</th>
                        <th>Subscriber Name</th>
                        <th>Company</th>
                        <th>Mobile No</th>
                        <th>Mesg Date</th>
                        <th>Message</th>
                        <th>Image Attached</th>                        
                        <th>Approve</th>                        
                    </tr>
                </thead>
                <tbody>
                    {messages.map((e,i)=>
                        <tr key={i}>
                            <td>{i+1}</td>
                            <td>{e.name}</td>
                            <td>{e.company}</td>
                            <td>{e.mobile}</td>
                            <td>{e.msgdate.split("T")[0].split("-").reverse().join("-")}</td>                                                        
                            <td>{e.message}</td>
                            <td><img src={e.datafile} onClick={()=>{window.open(e.datafile, '','width=500,height=500');}} style={{width:'30px',cursor:'pointer'}} /></td>                            
                            <td><img src={img1} style={{width:'30px',cursor:'pointer'}} onClick={()=>{approveMessage(e.id);}} /></td>
                        </tr>
                    )}
                </tbody>
            </table>            
            {progress && (
                    <div className="modal show d-block shadow modal-backdrop-custom"  tabIndex="-1">
                        <div className="modal-dialog modal-dialog-centered modal-md">
                                <div className="modal-body p-4">                                                                                                                                                
                                    <img src={loadIcon} alt="" style={{position:'fixed',left:'50%',top:'45%',width:'50px'}}/>
                                </div>                                                            
                        </div>
                    </div>
                )}
        </div>
    );
}
export default SubscriberMessages;